
import React, { useState } from "react";
import "./PostWorkModal.css";
import API from "../../../api";

export default function PostWorkModal({
  user = {},
  onClose = () => {},
  onWorkPosted = () => {}
}) {
  const [form, setForm] = useState({
    title: "",
    description: "",
    city: user.location?.city || "",
    state: user.location?.state || "",
    workType: "Project",
    duration: "",
    budget: "",
    budgetType: "Negotiable",
    skills: ""
  });

  const [loading, setLoading] = useState(false);

  const update = (key, value) => {
    setForm((prev) => ({
      ...prev,
      [key]: value
    }));
  };

  const handleSubmit = async () => {
  if (!form.title.trim()) {
    alert("Please enter a work title.");
    return;
  }

  if (!form.description.trim()) {
    alert("Please describe the work.");
    return;
  }

  if (!form.city.trim()) {
    alert("Please enter the work location.");
    return;
  }

  try {
    setLoading(true);

    const payload = {
      title: form.title.trim(),
      description: form.description.trim(),
      city: form.city.trim(),
      state: form.state.trim(),
      workType: form.workType,
      duration: form.duration.trim(),
      budget: form.budget
        ? Number(form.budget)
        : 0,
      budgetType: form.budgetType,
      skills: form.skills
        .split(",")
        .map((skill) => skill.trim())
        .filter(Boolean)
    };

    const res = await API.post(
      "/work-posts",
      payload
    );

    if (res.data.success) {
  alert("Work posted successfully.");

  onWorkPosted(res.data.workPost);
}else {
      alert(
        res.data.message ||
        "Unable to post work."
      );
    }

  } catch (err) {
    console.error("Work post failed:", err);

    alert(
      err.response?.data?.message ||
      "Unable to create work post."
    );

  } finally {
    setLoading(false);
  }
};

  return (
    <div
      className="post-work-backdrop"
      onClick={onClose}
    >
      <div
        className="post-work-modal"
        onClick={(e) => e.stopPropagation()}
      >

        {/* ================= HEADER ================= */}

        <div className="post-work-header">
          <div>
            <h2>Post a Work</h2>

            <p>
              Share a temporary work opportunity with the
              Civilink community.
            </p>
          </div>
        </div>

        {/* ================= BODY ================= */}

        <div className="post-work-body">

          {/* ================= WORK TITLE ================= */}

          <div className="post-work-section">
            <h3>Work Details</h3>

            <div className="form-group">
              <label>
                Work Title <span className="required">*</span>
              </label>

              <input
                type="text"
                placeholder="Example: Need Site Engineer"
                value={form.title}
                onChange={(e) =>
                  update("title", e.target.value)
                }
              />
            </div>

            <div className="form-group">
              <label>
                Description <span className="required">*</span>
              </label>

              <textarea
                rows={5}
                placeholder="Describe the work requirement..."
                value={form.description}
                onChange={(e) =>
                  update("description", e.target.value)
                }
              />
            </div>
          </div>

          {/* ================= LOCATION ================= */}

          <div className="post-work-section">
            <h3>Work Location</h3>

            <div className="post-work-grid">

              <div className="form-group">
                <label>
                  City <span className="required">*</span>
                </label>

                <input
                  type="text"
                  placeholder="City"
                  value={form.city}
                  onChange={(e) =>
                    update("city", e.target.value)
                  }
                />
              </div>

              <div className="form-group">
                <label>State</label>

                <input
                  type="text"
                  placeholder="State"
                  value={form.state}
                  onChange={(e) =>
                    update("state", e.target.value)
                  }
                />
              </div>

            </div>
          </div>

          {/* ================= WORK TYPE ================= */}

          <div className="post-work-section">
            <h3>Work Information</h3>

            <div className="post-work-grid">

              <div className="form-group">
                <label>Work Type</label>

                <select
                  value={form.workType}
                  onChange={(e) =>
                    update("workType", e.target.value)
                  }
                >
                  <option value="Project">
                    Project
                  </option>

                  <option value="Temporary">
                    Temporary
                  </option>

                  <option value="Part-time">
                    Part-time
                  </option>

                  <option value="Full-time">
                    Full-time
                  </option>

                  <option value="Contract">
                    Contract
                  </option>
                </select>
              </div>

              <div className="form-group">
                <label>Duration</label>

                <input
                  type="text"
                  placeholder="Example: 2 months"
                  value={form.duration}
                  onChange={(e) =>
                    update("duration", e.target.value)
                  }
                />
              </div>

            </div>

            {/* ================= BUDGET ================= */}

            <div className="post-work-grid">

              <div className="form-group">
                <label>Salary / Budget</label>

                <input
                  type="number"
                  min="0"
                  placeholder="Example: 25000"
                  value={form.budget}
                  onChange={(e) =>
                    update("budget", e.target.value)
                  }
                />
              </div>

              <div className="form-group">
                <label>Budget Type</label>

                <select
                  value={form.budgetType}
                  onChange={(e) =>
                    update(
                      "budgetType",
                      e.target.value
                    )
                  }
                >
                  <option value="Negotiable">
                    Negotiable
                  </option>

                  <option value="Per Day">
                    Per Day
                  </option>

                  <option value="Per Month">
                    Per Month
                  </option>

                  <option value="Fixed">
                    Fixed
                  </option>
                </select>
              </div>

            </div>
          </div>

          {/* ================= SKILLS ================= */}

          <div className="post-work-section">
            <h3>Required Skills</h3>

            <div className="form-group">
              <label>Skills</label>

              <input
                type="text"
                placeholder="AutoCAD, Site Supervision, Estimation"
                value={form.skills}
                onChange={(e) =>
                  update("skills", e.target.value)
                }
              />

              <small className="field-hint">
                Separate multiple skills with commas.
              </small>
            </div>
          </div>

          {/* ================= EXPIRY INFO ================= */}

          <div className="post-work-expiry">
            <strong>Temporary Work Post</strong>

            <p>
              This work post will automatically be removed
              after 5 days.
            </p>
          </div>

        </div>

        {/* ================= FOOTER ================= */}

        <div className="post-work-footer">

          <button
            className="profile-btn secondary"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>

          <button
            className="profile-btn primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Posting..." : "Post a Work"}
          </button>

        </div>

      </div>
    </div>
  );
}

